import React from 'react';
import PropTypes from 'prop-types';
import popOverBottom from './popover-bottom-view';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';

export const PasswordInput = ({
  name,
  label,
  onChange,
  onBlur,
  onFocus,
  inputType = 'password',
  maxLength,
  onViewAsTextClick,
  onViewAsTextByKeyboard,
  toggleAriaLabel,
  showForgotPassword = {},
  lettersNumbersRequirement = {},
  minCharacterCountRequirement = {},
  placeholder,
  value,
  error = '',
  helpText,
  isShallowGroup = false,
}) =>
  <div className={`form-group${isShallowGroup ? ' shallow' : ''}${error.length ? ' has-error' : ''}`}>
    <label id={`${name}-label`} htmlFor={`${name}-input`}>
      {label}
      {helpText &&
        <OverlayTrigger
          container={this}
          trigger="click"
          rootClose
          placement="bottom"
          overlay={popOverBottom(name, helpText)}>
          <i className="togo-icon togo-icon-question-circle togo-icon-question-circle-leftpadding help-icon-move-down" />
        </OverlayTrigger>}
    </label>
    <div className="control-block">
      <div className="input-group" style={{marginBottom: '0px'}}>
        <input
          id={`${name}-input`}
          type={inputType}
          className="form-control"
          placeholder={placeholder}
          value={value}
          maxLength={maxLength}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          title={label}
        />
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <span
          className="input-group-addon"
          id={`${name}_switch`}
          onClick={onViewAsTextClick}
          onKeyUp={onViewAsTextByKeyboard}
          role="button"
          tabIndex="0"
          aria-label={toggleAriaLabel}
          aria-pressed={inputType === 'text'}
        >
          <i className="togo-icon togo-icon-eye" />
        </span>
      </div>
      {error &&
        <p id={`${name}-error`} className="help-block">{error}</p>}
      {showForgotPassword.label &&
        <div id="forgot-password-link" className="passwordInfoText-block">
          <a href={showForgotPassword.href}>{showForgotPassword.label}</a>
        </div>}
      {lettersNumbersRequirement.label &&
        <div
          id="lettersNumbersRequirement"
          className={`passwordInfoText-block${lettersNumbersRequirement.isMet ? ' passwordRequirementMet' : ''}`}
        >
          {`* ${lettersNumbersRequirement.label}`}
        </div>}
      {minCharacterCountRequirement.label &&
        <div
          id="characterCountRequirement"
          className={`passwordInfoText-block${minCharacterCountRequirement.isMet ? ' passwordRequirementMet' : ''}`}
        >
          {`* ${minCharacterCountRequirement.label}`}
        </div>}
    </div>
  </div>;

PasswordInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  helpText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onViewAsTextClick: PropTypes.func,
  onViewAsTextByKeyboard: PropTypes.func,
  toggleAriaLabel: PropTypes.string.isRequired,
  showForgotPassword: PropTypes.object,
  lettersNumbersRequirement: PropTypes.object,
  minCharacterCountRequirement: PropTypes.object,
  placeholder: PropTypes.string,
  inputType: PropTypes.string,
  value: PropTypes.string,
  maxLength: PropTypes.string,
  error: PropTypes.string,
  isShallowGroup: PropTypes.bool,
};

export default PasswordInput;
